import styled from 'styled-components';

export const Wrapper = styled.div`
  width: 100%;
  display: inline-flex;
  height: 280px;
  padding: 24px;
  align-items: flex-start;
  gap: 24px;
  flex-shrink: 0;

  .ant-avatar {
    cursor: pointer;
  }

  & > div {
    flex: 1 1 0%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }

  & > div > div {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-top: 16px;
  }
`;

export const TitleWrapper = styled.span`
  font-family: ${({ theme }) => theme.fontFamily.primary};
  color: ${({ theme }) => theme.colors.black9};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 28px;
  letter-spacing: -0.2px;
`;
